import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AccessDenied() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="min-h-[60vh] flex items-center justify-center p-6" data-testid="access-denied">
      <div className="max-w-md text-center">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-red-50 border border-red-200">
          <ShieldAlert className="h-7 w-7 text-red-600" />
        </div>
        <p className="font-mono text-xs uppercase tracking-widest text-red-600 mb-2" data-testid="access-denied-code">403</p>
        <h1 className="font-display text-2xl font-bold text-navy mb-2">{t("forbidden.title")}</h1>
        <p className="text-sm text-slatebody mb-6">{t("forbidden.message")}</p>
        <Button onClick={() => navigate("/app/dashboard")} data-testid="access-denied-back">
          {t("forbidden.back")}
        </Button>
      </div>
    </div>
  );
}
